// import * as PIXI from 'pixi.js'
import { startFirstView, completeFirstView } from './firstView'
import { TweenMax, TimelineMax, TweenLite } from 'gsap/all'
import Video from '../video/main.mp4'
import Image from '../img/image1.jpg'
import clouds from "../img/filter/clouds.jpg"

let PIXI, GlitchFilter

if (typeof window !== `undefined`) {
  PIXI = require('/modules/pixi.js')
  GlitchFilter = require('@pixi/filter-glitch')
}

PIXI.utils.skipHello()
console.log(
  '%c powered by Fump %c https://fump.tech',
  'padding: 5px 2px; background-color: #000; color: #fff;',
  ''
)

// キャンバスの準備
const canvas = document.querySelector('.cvs')
let WIDTH = window.innerWidth
let HEIGHT = window.innerHeight
let originalVideoWidth = 1920
let originalVideoHeight = 1080
let targetWidth
let targetHeight

// filter
const filter = new PIXI.Sprite.from(clouds)
const displacementFilter = new PIXI.filters.DisplacementFilter(filter)

// video
const video = PIXI.BaseTexture.from(Video)
const source = video.resource.source
const videoResource = new PIXI.resources.autoDetectResource(source, {
  autoPlay: false,
  // crossorigin: true
})
source.muted = true
source.loop = true
const videoSprite = new PIXI.Sprite.from(videoResource)

// image
const image = new PIXI.Sprite.from(Image)

// appの準備
const app = new PIXI.Application({
  resolution: window.devicePixelRatio || 1,
  autoResize: true,
  width: WIDTH,
  height: HEIGHT,
  view: canvas,
  transparent: true
})
app.stage.interactive = true

// videoのStage準備
const videoStage = new PIXI.Container()

const App = () => {
  app.stage.addChild(videoStage)
  resizeVideo()
  setVideo()
  setFilter()
  setCoverImage()
  startTicker()
  source.pause()

  window.addEventListener('resize', resizeCanvas)
}

/**
 * ビデオをリサイズ
 *
 */
const resizeVideo = () => {
  let canvasRatio = HEIGHT / WIDTH
  let videoRatio = originalVideoHeight / originalVideoWidth
  if (canvasRatio > videoRatio){
    targetHeight = HEIGHT / 1.8
    targetWidth = HEIGHT * (originalVideoWidth / originalVideoHeight) / 1.8
  } else {
    targetWidth = WIDTH / 1.8
    targetHeight = WIDTH * (originalVideoHeight / originalVideoWidth) / 1.8
  }
}

const setVideo = () => {
  videoSprite.width = targetWidth
  videoSprite.height = targetHeight
  videoSprite.anchor.set(0.5)
  videoSprite.position.x = WIDTH / 2
  videoSprite.position.y = HEIGHT / 2
  videoSprite.interactive = true
  videoSprite.alpha = 0
  videoStage.addChild(videoSprite)
}

// フィルターつける
const setFilter = () => {
  videoStage.filters = [displacementFilter]
  filter.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT
  displacementFilter.padding = 10
  filter.scale.x = 1.5
  filter.scale.y = 1.5
  videoStage.addChild(filter)
}

// フィルターを動かす
const startTicker = () => {
  const ticker = new PIXI.Ticker()
  ticker.add(delta => {
    filter.x += 3
    filter.y += 3
    app.render(videoStage)
  })
  ticker.start()
}

// 画像
const setCoverImage = () => {
  image.width = targetWidth
  image.height = targetHeight
  image.anchor.set(0.5)
  image.position.x = WIDTH / 2
  image.position.y = HEIGHT / 2
  videoStage.addChild(image)
}

// マウスエフェクト
// const mouseEffect = (e) => {
//   const centerX = WIDTH / 2
//   const centerY = HEIGHT / 2
//   let x = e.data.global.x
//   let y = e.data.global.y
//   let degX = (x - centerX) * 0.1
//   let degY = (y - centerY) * 0.1

//   if(canvas !== e.target) {
//     x = x + e.data.global.x
//     y = y + e.data.global.y
//   }
//   videoSprite.position.x = WIDTH / 2 + degX
//   videoSprite.position.y = HEIGHT / 2 + degY
//   image.position.x = WIDTH / 2 + degX
//   image.position.y = HEIGHT / 2 + degY
// }
// videoSprite.on('mousemove', mouseEffect)

const GlitchFilterObjectStart = {
  slices: 30,
  offset: 30,
  fillMode: 1,
  red: [-15, 0],
  green: [0, 15],
  blue: [0, 0],
  direction: 2,
  seed: 0
}
const glitchStartFilter = new GlitchFilter.GlitchFilter(GlitchFilterObjectStart)
glitchStartFilter.name = 'glitch-start'

// ホバーでcoverImageを消して動画を再生
let isPlayed = false
const showVid = () => {
  if (isPlayed) return
  source.play()
  TweenMax.to(image, .20, { alpha: 0 })
  TweenMax.to(videoSprite, .20, { alpha: 1 })

  const tl = new TimelineMax({ repeatDelay: .25 })
  tl.to(videoSprite.position, .10, {
    x : WIDTH / 2 + 5,
    // y : HEIGHT / 2 + 5,
  })
  tl.to(videoSprite.position, .10, {
    x : WIDTH / 2 + -5,
    // y : HEIGHT / 2 + -5,
  })
  tl.to(videoSprite.position, .05, {
    x : WIDTH / 2 + 0,
    // y : HEIGHT / 2 + 0,
  })

  videoStage.filters.push(glitchStartFilter)
  TweenMax.to(GlitchFilterObjectStart, .20, {
    onComplete: () => {
      const target = videoStage.filters.find(object => {
        return object.name === 'glitch-start'
      })
      const index = videoStage.filters.indexOf(target)
      videoStage.filters.splice(index, 1)
    }
  })
  isPlayed = true
}

const GlitchFilterObjectStop = {
  slices: 10,
  offset: 120,
  fillMode: 1,
  red: [-15, 0],
  green: [0, 15],
  blue: [0, 0],
  direction: -1,
  seed: 0
}
const glitchStopFilter = new GlitchFilter.GlitchFilter(GlitchFilterObjectStop)
glitchStopFilter.name = 'glitch-stop'

const hideVid = () => {
  if (!isPlayed) return
  source.pause()

  const tl = new TimelineMax({ repeatDelay: .25 })
  tl.to(videoSprite.position, .10, {
    x : WIDTH / 2 + 8,
    // y : HEIGHT / 2 + 5,
  })
  tl.to(videoSprite.position, .10, {
    x : WIDTH / 2 + -8,
    // y : HEIGHT / 2 + -5,
  })
  tl.to(videoSprite.position, .05, {
    x : WIDTH / 2 + 0,
    // y : HEIGHT / 2 + 0,
  })

  videoStage.filters.push(glitchStopFilter)

  TweenMax.to(GlitchFilterObjectStop, .20, {
    onComplete: () => {
      const target = videoStage.filters.find(object => {
        return object.name === 'glitch-stop'
      })
      const index = videoStage.filters.indexOf(target)
      videoStage.filters.splice(index, 1)
    }
  })
  isPlayed = false
}

// SPでPlayボタンで再生・停止
const playButton = document.querySelector('.playButton')
const playPause = () => {
  if(!playButton.classList.contains('onplay')) {
    showVid()
    playButton.classList.add('onplay')
  } else {
    hideVid()
    playButton.classList.remove('onplay')
  }
}
playButton.addEventListener('click', playPause)

// リサイズ
const resizeCanvas = () => {
  resizeVideo()
  WIDTH = window.innerWidth
  HEIGHT = window.innerHeight
  app.renderer.resize(WIDTH, HEIGHT)
  videoSprite.width = targetWidth
  videoSprite.height = targetHeight
  videoSprite.anchor.set(0.5)
  videoSprite.position.x = WIDTH / 2
  videoSprite.position.y = HEIGHT / 2
  image.position.x = WIDTH / 2
  image.position.y = HEIGHT / 2
}

window.addEventListener('load', function() {
  App()
  this.setTimeout(function() {
    completeFirstView()
  }, 2000)
})
